import React from "react";

export default function Scrollbar({ children }) {
  return (
    <div className="flex flex-col overflow-y-scroll w-full h-full">
      {children}
    </div>
  );
}
